export default function EFOther() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="56" height="57" viewBox="0 0 56 57" fill="none">
            <rect x="8.8" y="12.8" width="38.4" height="13.4" rx="2.2" stroke="#ECECEC" strokeWidth="1.6" />
            <rect x="8.8" y="30.8" width="38.4" height="13.4" rx="2.2" stroke="#ECECEC" strokeWidth="1.6" />
            <rect x="25" y="16" width="6" height="2" rx="1" fill="#ECECEC" />
            <rect x="25" y="34" width="6" height="2" rx="1" fill="#ECECEC" />
        </svg>
    );
}
